module.exports = __webpack_public_path__ + "static/media/website-01.03a47d11.png";